import tippy from "tippy.js";
import "./tooltips.scss";

tippy(".hover-tooltip", {
  allowHTML: true,
  interactive: true,
});
